<template>
  <VDialog v-model="isShowModal" max-width="600" persistent>
    <VToolbar color="primary" density="compact">
      <VToolbarTitle>
        <!-- <VIcon icon="mdi-plus" class="mr-2" /> -->
        New Category
      </VToolbarTitle>
      <VSpacer />
      <VBtn icon="mdi-close" variant="text" @click="handleCancel" :disabled="isLoading" />
    </VToolbar>
    <VCard>
      <VCardItem>
        <VForm v-model="formValid" @submit.prevent class="mb-3 my-2">
          <VRow>
            <VCol cols="12">
              <VCombobox
                label="Category Name"
                variant="outlined"
                v-model="form.value"
                :items="categorySearchOptions"
                :rules="formRules.value"
                :hide-no-data="true"
                :loading="isLoadingCategories"
                :disabled="isLoading"
                autofocus
                :maxlength="255"
                counter
              ></VCombobox>
            </VCol>
            <VCol cols="12" v-if="type === 'Main Category'">
              <VTextarea
                label="Description"
                v-model="form.description"
                variant="outlined"
                prepend-inner-icon="mdi-text"
                :maxlength="255"
              ></VTextarea>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoading" class="mb-2" type="submit" color="primary" block flat @click="handleSubmit()">
                Create
              </VBtn>
              <VBtn :disabled="isLoading" color="grey-100" block flat @click="handleCancel()">Cancel</VBtn>
            </VCol>
          </VRow>
        </VForm>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import requestsService from '@/services/requests-service/requests.service';
// Text
import { successAddCategoryText, errorAddCategoryText } from '@/text/snackbarsText';
export default {
  name: 'CreateCategoryModal',

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    requestId: {
      type: String
    }
  },

  emits: ['update:modelValue', 'saved'],

  computed: {
    isShowModal() {
      return this.modelValue;
    }
  },

  watch: {
    modelValue: {
      handler() {
        if (this.modelValue) {
          this.getCategories();
        }
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      isLoading: false,
      isLoadingCategories: false,
      form: {
        value: '',
        description: ''
      },
      formValid: false,
      formRules: {
        value: [(v) => !!v || 'Category Name required']
      },
      categorySearchOptions: []
    };
  },

  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async getCategories() {
      this.isLoadingCategories = true;
      try {
        const categoryData = {
          type: this.type,
          requestId: this.requestId
        };
        const { categories } = await requestsService.searchCategories(categoryData);
        this.categorySearchOptions = categories ?? [];
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingCategories = false;
      }
    },
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoading = true;
        try {
          const categoryData = {
            value: this.form.value,
            type: this.type,
            requestId: this.requestId,
            description: this.form.description
          };
          const { category } = await requestsService.addNewCategory(categoryData);
          this.showSnackbar({ text: successAddCategoryText, color: 'green' });
          this.handleSuccess(category);
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: errorAddCategoryText, color: 'red' });
        } finally {
          this.isLoading = false;
        }
      }
    },

    handleSuccess(category) {
      this.$emit('saved', category);
      this.handleCancel();
    },

    handleCancel() {
      this.$emit('update:modelValue', false);
      this.resetForm();
    },

    resetForm() {
      this.form = {
        value: ''
      };
    }
  }
};
</script>
